<template>
  <div class="proCardPanel">
    <div class="borderLeft"><i class="el-icon-caret-right"></i>项目信息</div>
    <div class="projectCardList">
      <div v-for="(item,idx) in projectList" :key="idx" class="proCard">
          <span class="title-box" :title="item.EaAreaName">
            {{item.EaAreaName}}
            <i
              class="danger-icon"
              @click.prevent="showDanderInfo(item)"
              v-if="item.HiddendangerVo"
            >
              <img src="./img/danger.png" />
            </i>
          </span>
          <span :title="item.EaAreaExternalCode">物业项目编号：{{item.EaAreaExternalCode}}</span>
          <span :title="item.CantonName">所属行政区：{{item.CantonName}}</span>
          <span :title="item.EaAreaType">物业项目类型：{{item.EaAreaType}}</span>
      </div>
    </div>
    <!-- 分页 -->
    <div class="footer">
      <ps-page :page="page" @getData="getData()"></ps-page>
    </div>
    <el-dialog
      title="安全隐患"
      :visible.sync="managerDangerDialog"
      width="30%"
      :close-on-click-modal="false"
      custom-class="manager-danger-dialog"
    >
      <div class="danger-info">
        <div class="area-name">
          项目{{ dangerInfo.HiddendangerVo?.EaAreaName }}有如下安全隐患问题：
        </div>
        <div
          class="item-info"
          v-for="(item, index) in dangerInfo.HiddendangerVo?.TypeVos"
          :key="item.SafeHdType"
        >
          {{ index + 1 }}、{{ item.SafeHdName }}
        </div>
        <div class="info-time">
          登记时间：
          {{
            dangerInfo.HiddendangerVo?.CreateTime | formatDate('yyyy年MM月dd日')
          }}
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import { Page } from '@/models/page.js';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';
export default {
  name: 'proCardPanel',
  components: {},
  data() {
    return {
      projectList: [],
      startIndex: 0,
      page: new Page(),
      maxSize: 9,
      managerDangerDialog: false,
      dangerInfo: {},
    };
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {
    this.homePageControllerSvr = new HomePageControllerSvr();
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 安全隐患标识点击
    showDanderInfo(item) {
      this.managerDangerDialog = true;
      this.dangerInfo = item;
    },
    getData() {
      this.startIndex =
        this.page.currentPage > 1
          ? (this.page.currentPage - 1) * this.page.currtNum
          : 0;
      this.maxSize = this.page.currtNum;
      this.homePageControllerSvr
        .getAreaList(this.token, this.startIndex, this.maxSize)
        .then((res) => {
          this.projectList = res._Items;
          this.page.getCurrtNum = res.TotalCount;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.proCardPanel {
  overflow: hidden;
  height: 100%;
  background: white;
}
.borderLeft {
  border-bottom: 1px solid #e2e2e2;
  padding: 0px 0px 12px 6px;
  margin: 12px 0px 0px 0px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  i {
    color: #0f77f2;
    font-size: 18px;
  }
}
.projectCardList {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 12px 0px 12px 24px;
  height: calc(100% - 160px);
  overflow: auto;
  .proCard {
    border: 1px solid #e2e2e2;
    width: calc(33.33% - 24px);
    height: 140px;
    margin-right: 24px;
    margin-bottom: 12px;
    padding: 12px;
    box-shadow: 0 0 6px #a9a9a994;
    span {
      display: block;
      margin-top: 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      overflow: hidden;
    }
    .title-box{
      height: 32px;
      margin-top: 0px;
      font-weight: 600;
      font-size: 15px;
      position: relative;
      .danger-icon{
        position: absolute;
        display: inline-block;
        top: -2px;
        margin-left: 6px;
        width: 18px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
  }
}
.footer {
  text-align: right;
  line-height: 44px;
  padding-right: 6px;
}
.manager-danger-dialog {
  .el-dialog__header {
    border: none;
    padding: 14px 20px;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-dialog__headerbtn {
      top: 14px;
    }
  }
  .el-dialog__body {
    padding: 20px 15px 30px 15px;
    .danger-info {
      color: #333333;
      font-size: 16px;
      margin-left: 40px;
      line-height: 38px;
      .item-info {
        padding-left: 40px;
      }
    }
  }
}
</style>
